import Vue from "vue"
import Router from "vue-router"
import Layout from '@/layout/index'
import {PAGE_NAME} from "@/assets/js/config.js"

Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   name: "login",
    //   component: () => import("../views/login/login")
    // },
    {
      path: '/',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/index")
        }
      ]
    },
    {
      path: '/gywm',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/gywm/index")
        }
      ]
    },
    {
      path: '/zx',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fu/index")
        }
      ]
    },
    {
      path: '/cs',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fu/test")
        }
      ]
    },
    {
      path: '/yykf',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fu/use")
        }
      ]
    },
    {
      path: '/rpa',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/cp/rpa")
        }
      ]
    },
    {
      path: '/zdhcs',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/cp/cs")
        }
      ]
    },
    {
      path: '/sjkgj',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/cp/gj")
        }
      ]
    },
    {
      path: '/sjfxl',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/cp/fxl")
        }
      ]
    },
    {
      path: '/qc',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/qc")
        }
      ]
    },
    {
      path: '/ky',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/ky")
        }
      ]
    },
    {
      path: '/kx',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/kx")
        }
      ]
    },
    {
      path: '/jr',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/jr")
        }
      ]
    },
    {
      path: '/xny',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/xny")
        }
      ]
    },
    {
      path: '/fdc',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/dc")
        }
      ]
    },
    {
      path: '/jk',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/',
          component: () => import("../views/fa/jk")
        }
      ]
    }
  ]
});